import React, {useEffect, useState} from 'react';
import CopyButton from "../../cmp/CopyButton";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import RenderDiscountValue from "./components/RenderDiscountValue";
import Modal from "../../cmp/Modal";
import Label from "../../auth/components/Label";
import {post} from "../../../api";
import {useSelector, useDispatch} from 'react-redux'
import {actionMergeSetting} from "../../../redux/settings/settingsAction";
const reducer  = (state)=>state.settings.status;
function PersonalDiscount ({personal_coupon, account_status, personal_coupon_change_allowed}){
    const [changingCoupon, setChangingCoupon] = useState(null)
    const status = useSelector(reducer)
    if(!personal_coupon || personal_coupon.length === 0) {
            return null;
    }
    return (
        <>
            <PersonalCouponChangeModal
                visible={!!changingCoupon} defaultCoupon={changingCoupon} onClose={()=>setChangingCoupon(null)} />
            <h4><FormattedMessage id={"Personal Discount"}/></h4>
            <p className={"text-muted"}>
                <FormattedMessage id={"Personal discount description"} />
            </p>
            {
                personal_coupon.map(({code, discount_type, id, price_rule_id, discount_amount, discount_value})=>{
                    return <div key={code}>
                        <small>
                            <FormattedMessage id={'couponCode'}/>
                            <RenderDiscountValue coupon={{discount_type, discount_amount: discount_amount || discount_value}}/>
                        </small>
                      <h4>{['pending', 'blocked'].indexOf(account_status) < 0 ? code : code.replace(/./g, "*")}</h4>
                        <CopyButton text={code}/>
                        {
                            (id || price_rule_id) && account_status === 'approved' && personal_coupon_change_allowed && (
                                <div>
                                    <button className="btn btn-link px-0" onClick={()=>setChangingCoupon(code)}>
                                        <FormattedMessage id={'changeCoupon'}/>
                                    </button>
                                </div>)
                        }
                    </div>

                })
            }

       </>
    );
}

function PersonalCouponChangeModal({visible, onClose, defaultCoupon}){
    const personal_coupon = useSelector((state)=>state.settings.personal_coupon)
    const dispatch = useDispatch()
    const [newCoupon, setNewCoupon] = useState('')
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    useEffect(()=>{
        setNewCoupon(defaultCoupon)
    },[defaultCoupon])
    function updateCoupon(e){
        if(e){
            e.preventDefault();
            e.stopPropagation();
        }
        if(defaultCoupon.trim() === newCoupon.trim()){
            return onClose()
        }
        setLoading(true)
        post('/coupon',{
            old_coupon: defaultCoupon,
            coupon_code: newCoupon,
            type:'personal'
        }).then((data)=>{
            if(data.error){
                setError(data.error)
            }else{
                dispatch(actionMergeSetting({personal_coupon:personal_coupon.map((item) => {
                        if (item.code === defaultCoupon) {
                            return {...item, code: data.coupon}
                        } else {
                            return item;
                        }
                })}))
                ;
                onClose(true)
            }
            setLoading(false)
        })
    }
    return <Modal onCancel={onClose}
           visible={visible}
           disabled={!defaultCoupon || !newCoupon || defaultCoupon.trim() === newCoupon.trim()}
           onSubmit={updateCoupon}
           title={<FormattedMessage id={'changeCoupon'}/>}
           confirmLoading={loading}
           okText={<FormattedMessage id={'Update'}/>}
           cancelText={<FormattedMessage id={'Cancel'}/>}>
        <p>
            <FormattedMessage id={'changeCouponModalDescription'}/>
        </p>
        <div className="form-group">
            <Label><FormattedMessage id={'couponCode'}/></Label>
            <input className="form-control"
                   value={newCoupon}
                   onChange={(e)=>setNewCoupon(e.target.value)}/>
        </div>
        {
            error && <p className={'text-danger'}>{error}</p>
        }
    </Modal>
}

function mapStateToProps(state) {
    const {personal_coupon, status, personal_coupon_change_allowed} = state.settings;
    return {
        personal_coupon,
        account_status: status,
        personal_coupon_change_allowed,
    }
}

export default connect(mapStateToProps)(PersonalDiscount);
